import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import {AccessibilityService, HotkeyType} from '../services/accessibility.service';
import {FocusUtil} from '../utils/focus.util';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[a11yFocusBlock]',
    standalone: false
})
export class FocusBlockDirective {
    private elementRef = inject(ElementRef);
    private accessibilityService = inject(AccessibilityService);

    protected getElementRef(): ElementRef {
        return this.elementRef;
    }

    protected onHomeOrEnd($event) {
        const isHomePressed = this.accessibilityService.checkHotkey($event, HotkeyType.FOCUS_FIRST);
        const isEndPressed = this.accessibilityService.checkHotkey($event, HotkeyType.FOCUS_LAST);
        if (!isHomePressed && !isEndPressed) {
            return;
        } else {
            const focusableElements = FocusUtil.findCoarseFocusableElements(this.elementRef.nativeElement);
            if (isHomePressed) {
                const firstFocusableElement = Array.from(focusableElements).find((focusableElement) => FocusUtil.isKeyboardFocusable((focusableElement as HTMLElement)));

                if (firstFocusableElement) {
                    (firstFocusableElement as HTMLElement).focus();
                    $event.preventDefault();
                }
            } else if (isEndPressed) {
                const lastFocusableElement = Array.from(focusableElements).reverse().find((focusableElement) => FocusUtil.isKeyboardFocusable((focusableElement as HTMLElement)));

                if (lastFocusableElement) {
                    (lastFocusableElement as HTMLElement).focus();
                    $event.preventDefault();
                }
            }
        }
    }

    @HostListener('keydown', ['$event']) onKeyDown($event){
        this.onHomeOrEnd($event);
    }
}
